import { render, staticRenderFns } from "./editPublish.vue?vue&type=template&id=33b7ef84&scoped=true&"
import script from "./editPublish.vue?vue&type=script&lang=js&"
export * from "./editPublish.vue?vue&type=script&lang=js&"
import style0 from "@assets/css/mediaDetails/mediaCreat.less?vue&type=style&index=0&id=33b7ef84&lang=less&scoped=true&"
import style1 from "./editPublish.vue?vue&type=style&index=1&id=33b7ef84&lang=less&scoped=true&"
import style2 from "./editPublish.vue?vue&type=style&index=2&lang=less&"
import style3 from "./editPublish.vue?vue&type=style&index=3&id=33b7ef84&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b7ef84",
  null
  
)

component.options.__file = "editPublish.vue"
export default component.exports